import { TangramList } from './../../../../shared';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
import { Component, HostListener, OnInit, Renderer2, ViewChild, OnChanges, SimpleChanges, OnDestroy, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertModalService } from 'src/app/shared/services/alert-modal.service';
import { CommonService } from 'src/app/_services/common.service';
import { appConfig } from 'src/app/_core/config/app-config.const';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { environment } from 'src/environments/environment';
import { NgNavigatorShareService } from 'ng-navigator-share';
import { ToastrService } from 'ngx-toastr';
import { TinyUrlService } from '../../services/tinyurl.service';
import _Swal from 'sweetalert2';

@Component({
  selector: 'my-bookmarks',
  templateUrl: './my-bookmarks.component.html',
  styleUrls: ['./my-bookmarks.component.scss'],
})
export class MyBookmarkComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('EmbedModalPopupContent', { static: true }) embedModalPopupContent!: TemplateRef<any>;
  imgPath = appConfig.imagePath;
  iconPath = appConfig.iconPath;
  myBookmarksList: any[];
  showSideMenuBar: boolean = false;
  currentUser: any;
  placeholderImage: string = "assets/img/videos/img6.png";
  shareUrl: string = '';
  fbShareUrl: string = '';
  inAppShareUrl:string = '';
  whatsAppShareUrl: string = '';
  whatsAppShareUrl1: string = '';
  CurrentSharePathwayId: string = '';
  imgEnvPath = environment.backendUrl;
  currentTangramId: string = "";
  private ngNavigatorShareService: NgNavigatorShareService;
  isIOS: boolean = false;

  viewMode: 'grid' | 'list' = 'grid';
  openMenuId: string = '';
  totalViews: number = 0;
  totalVisitors: number = 0;
  totalFavorites: number = 0;
  totalComments: number = 0;
  isLoading: boolean = true;
  constructor(
    private modalService: NgbModal,
    private cd: ChangeDetectorRef,
    private renderer: Renderer2,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private dashboardService: DashboardService,
    ngNavigatorShareService: NgNavigatorShareService,
    private toasterService: ToastrService,
    private tinyUrlService: TinyUrlService,
    private alertModalService: AlertModalService,
    ) {
      this.currentUser = this.authService.currentUserValue;
      this.ngNavigatorShareService = ngNavigatorShareService;

    }

  /**
   * Called when input properties get changed
   * @param changes changes to be got
   */
  ngOnChanges(_changes: SimpleChanges) {
    console.log('my-bookmark input changes');
  }

  /**
   * Called when component being called
   */
  ngOnInit() {
    this.getBookmark();
    this.isIOS = /iphone|ipad/i.test(navigator.userAgent);
    this.fbShareUrl = environment.fbShareUrl;
    const details = navigator.userAgent;
    this.inAppShareUrl = environment.inAppShareUrl;
    const regexp = /android|iphone|kindle|ipad/i;

    /* Using test() method to search regexp in details
    it returns boolean value*/
    const isMobileDevice = regexp.test(details);
    if (isMobileDevice) {
      this.whatsAppShareUrl=environment.whatsAppShareUrlMobile;
    } else {
      this.whatsAppShareUrl=environment.whatsAppShareUrl;
    }
    
  }

  getBookmark() {
    const data = {
      userId : this.currentUser._id
    };
    this.dashboardService.getMyBookmarksList(data).subscribe((response: TangramList<any[]>) => {
      this.myBookmarksList = response.data ? response.data.reverse() : [];
      this.myBookmarksList.forEach( (el, i) => {
        if (el.imageURL) {
          this.myBookmarksList[i].overviewImageUrl = `${environment.backendUrl}${el.imageURL}`;
        } else if (el.tempImageURL) {
          this.myBookmarksList[i].overviewImageUrl = el.tempImageURL;
        } else {
          this.myBookmarksList[i].overviewImageUrl = "assets/img/videos/img6.png";
        }
      });
      this.computeStats();
      this.isLoading = false;
    }, () => {
      this.isLoading = false;
    });
  }

  private computeStats() {
    const list = this.myBookmarksList || [];
    this.totalViews     = list.reduce((s, t) => s + (Number(t.totalViewCount) || 0), 0);
    this.totalVisitors  = list.reduce((s, t) => s + (Number(t.users) || 0), 0);
    this.totalFavorites = list.reduce((s, t) => s + (Number(t.favorites) || 0), 0);
    this.totalComments  = list.reduce((s, t) => s + (Number(t.totalCommentCount) || 0), 0);
  }

  toggleCardMenu(id: string, event?: Event) {
    if (event) { event.stopPropagation(); }
    this.openMenuId = this.openMenuId === id ? '' : id;
  }

  @HostListener('document:click')
  closeMenuOnOutsideClick() {
    if (this.openMenuId) { this.openMenuId = ''; }
  }

  /**
   * Toggle side menu bar
   */
  toggleSideMenuBar($event: Event) {
    console.log('inside toggleSideMenuBar');
    $event.stopPropagation();
    this.showSideMenuBar = !this.showSideMenuBar;
    // Hide show side menu bar based on status
    if (this.showSideMenuBar) {
      this.renderer.addClass(document.body, 'menu-open');
    }
    else {
      this.renderer.removeClass(document.body, 'menu-open');
    }
  }

  /**
   * Toggle side menu bar when click anywhere
   * @param event
   */
  onClick(event) {
    console.log('inside onClick event');
    if (this.showSideMenuBar) {
       this.toggleSideMenuBar(event);
    } else {
      this.renderer.removeClass(document.body, 'menu-open');
    }
  }

  
  /**
   * navigate to create a new tangram page
   */
  navigateToPathwayDetails(pathway: any) {
    const pathwayId = pathway._id;
    this.router.navigate(['/dashboard', pathwayId]);
  }

  //logout user
  logout() {
    this.authService.logout();
    this.router.navigate(["/home"]);
  }

  /**
   * Called when component being destroyed
   */
  ngOnDestroy() {
    console.log('my-bookmark component destroyed');
  }

  /**
 * redirects user to share popup
 * @param link to be shared
 */
  shareRedirect(appUrl,link) {
    const shareURL = appUrl + encodeURIComponent(link);
    window.open(shareURL,'popup','width=600,height=600'); 
    return false;
  }  

  copyLink(_type){
    // loading the content into our clipboard
    const link = this.shareUrl;
    navigator.clipboard.writeText(link);
  }

  async openSharePopup(pathwayId) {
    if(this.CurrentSharePathwayId && this.CurrentSharePathwayId !== pathwayId) {
      const popup = document.getElementById("share-popup" + this.CurrentSharePathwayId);
      const btnPopup = document.getElementById("shareBtn" + this.CurrentSharePathwayId);
      if(popup) {
        popup.classList.toggle("show");
      }
      if(btnPopup) {
        btnPopup.classList.toggle("visible");
      }
    }
    // Current origin → link matches the running environment (localhost /
    // staging / production), not the hardcoded appRedirectUrl.
    const link = window.location.origin + '/#/dashboard/' + pathwayId
    this.shareUrl = await this.shortenUrlFunc(link);
    const urlInput = document.getElementById("share-tangram-url" + pathwayId);
    if (urlInput) urlInput.setAttribute('value', this.shareUrl);
    const popup = document.getElementById("share-popup" + pathwayId);
    const btnPopup = document.getElementById("shareBtn" + pathwayId);
    
    if(this.isIOS){
      this.ngNavigatorShareService.share({
        title: '',
        url: this.shareUrl
      }).then( (response) => {
        console.log(response);
      })
      .catch( (error) => {
        console.log(error);
      })    
    }else{
      if(popup) {
        popup.classList.toggle("show");
      }
      if(btnPopup) {
        btnPopup.classList.toggle("visible");
      }
    }
    if(this.CurrentSharePathwayId && this.CurrentSharePathwayId === pathwayId) {
      this.CurrentSharePathwayId = '';
    } else {
      this.CurrentSharePathwayId = pathwayId;
    }
  }

  /**
   * Open share modal
   * @param content content to be displayed as modal
   */
  openShareModal(content) {
    this.modalService.open(content, { centered: true }).result.then(() => {
    }, () => {
    });
  }

  /**
   * Update overview image url if given url is not valid
   * @param event
   */
  updateOverviewImageUrl(event, i) {
    this.myBookmarksList[i].overviewImageUrl = "assets/img/videos/img6.png";
  }

  async shortenUrlFunc(longUrl) {
    try {
      const response: any = await this.tinyUrlService.shortenUrl(longUrl).toPromise();
      return response.data.tiny_url; // Return the shortened URL
    } catch (error) {
      console.error('Error occurred while shortening URL:', error);
        this.toasterService.error(error)
        return longUrl;
      }
  }

  removeBookmark() {
    const data = {
      isBookmarked: false,
      userId: this.currentUser._id,
      pathwayId: this.currentTangramId
    }
    this.dashboardService.bookmarkPathway(data).subscribe((_response: any) => {
      this.getBookmark();
    });
    // Swal.fire({
    //   html: "Do you want to remove this bookmark ?",
    //   icon: 'info',
    //   showCancelButton: true,
    //   confirmButtonText: 'Yes, Remove',
    //   focusConfirm: false,
    //   cancelButtonText: 'No',
    //   reverseButtons: true
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     let data = {
    //       isBookmarked: false,
    //       userId: this.currentUser._id,
    //       pathwayId: pathwayId
    //     }
    //     this.dashboardService.bookmarkPathway(data).subscribe((response: any) => {
    //       this.getBookmark();
    //     });
    //   }
    // }).catch(er => {
    //   console.log(er)
    // });
  }

  showPopup(tangramId) {
    this.currentTangramId = tangramId;
    this.alertModalService.confirm({
      title: 'Remove Bookmark',
      message: 'Do you want to remove this bookmark ?',
      cancelText: 'No',
      confirmText: 'Yes, Remove',
    }).subscribe(confirmed => { if (confirmed) this.removeBookmark(); });
  }

  /**
   * Open embed modal
   */
  openEmbedModal(pathwayId: string) {
    this.CurrentSharePathwayId = pathwayId;
    this.modalService.open(this.embedModalPopupContent, { 
      centered: true, 
      windowClass: 'embed-modal-popup',
      size: 'lg'
    });
  }
}


